export default {
  'facility-selection.list-title': 'Please select a facility',
  'facility-selection.appointment-types': 'Appointment types',
  'facility-selection.no-appointment-types':
    'We are very sorry. We are currently performing maintenance.',

  'facility-selection.list-description':
    'Please select a facility to book an appointment.',
  'facility-selection.list.facility-disabled':
    'You must verify your email before you can book any more appointments at this facility.',
  'facility-selection.list-description.clinic':
    'Select the desired facility for which you would like to book an appointment.',
  'facility-selection.search-placeholder':
    'Search facility or department, e.g. surgery',
  'facility-selection.contact.title': '{facilityName} contact',
  'facility-selection.contact.emergency':
    'Please contact the facility by phone if it is an emergency.',
  'facility-selection.contact.doctolib': 'Booking via Doctolib',
  'facility-selection.opening-hours.title': 'Opening hours',
  'facility-selection.visiting-hours.title': 'Visiting hours',
  'facility-selection.closed': 'Closed',
  'facility-selection.no-description': 'No further description available',
  'facility-selection.next-available-appointments': 'Next available appointments',
  'facility-selection.no-next-available-appointments':
    'There are currently no more available dates for this facility',
  'facility-selection.no-data': 'No facilities were found for your search term',
  'facility-selection.select-type':
    'Please select an appointment type and an appointment location to view the next available appointments.',
  'facility-selection.appointment-booking': 'Appointment booking',
  'facility-selection.appointment-request': 'Appointment request',
  'facility-selection.appointment-request.request': 'Request appointment',

  'facility-selection.appointment-locations': 'Appointment location',
  'facility-selection.appointment-locations.select-appointment-type':
    'Please select an appointment type to view the available appointment locations.',

  'facility-details.contact': 'Contact',

  'facility-selection-help.title': 'Do you need help?',
  'facility-selection-help.text':
    'To book an appointment, please first select the desired facility from the list. You cannot book appointments directly at all facilities. In this case, please select the desired sub-facility.',

  'facility-selection.appointment-request.description':
    'An appointment request is required for this type of appointment. You will be informed about the appointment details by the clinic after your request has been processed.',

  'facility-selection.slot-selection.description':
    'This type of appointment requires confirmation from the selected facility.',

  'facility-selection.frequently-asked-questions': 'Frequently asked questions',

  'appointment-type.frequently-asked-questions': 'Frequently asked questions about this appointment type',
};
